var app = angular.module('leonardo');

var FolderAddDialog = function (
  $scope,
  FolderService,
  $rootScope,
  $state,
  AuthDataService,
  FormErrorsService,
  AccountUserService,
  $q,
  AccountUserRoleService,
  PermissionService,
  blockUI
) {
  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';
  $scope.action = $scope.ngDialogData.action;
  $scope.entity = $scope.ngDialogData.entity;
  $scope.parent = $scope.ngDialogData.parent;
  // Get the folder dialog block instance
  $scope.blockInstance = blockUI.instances.get('folder-dialog-block');

  $scope.namePattern = {
    pattern: new RegExp('^[a-zA-Z0-9-_. ]*$'),
    text: 'Naming convention can be alphanumeric and might even include a "-", "_" or "."'
  };

  $scope.roles = [];

  $scope.visible_roles = [];
  angular.forEach($scope.entity.visible_by_roles, function (role) {
    $scope.visible_roles.push(role.id);
  });

  $scope.editable_roles = [];
  angular.forEach($scope.entity.editable_by_roles, function (role) {
    $scope.editable_roles.push(role.id);
  });

  $scope.data = {
    account: $scope.entity.account,
    name: $scope.entity.name,
    order: $scope.entity.order,
    linked_flag: $scope.entity.linked_flag,
    requirements: $scope.entity.requirements,
    sector: $scope.entity.sector,
    private: $scope.entity.private,
    visible_by_roles: $scope.visible_roles,
    editable_by_roles: $scope.editable_roles,
    propagate_to_subfolders: $scope.entity.propagate_to_subfolders
  };

  if ($scope.action === 'create') {
    switch ($scope.mode) {
      case 'property':
        $scope.data.type = FolderService.TYPE_PROPERTY;
        break;
      case 'portfolio':
        $scope.data.type = FolderService.TYPE_PORTFOLIO;
        break;
      case 'account':
        $scope.data.type = FolderService.TYPE_ACCOUNT;
        break;
      default:
        $scope.data.type = FolderService.TYPE_NORMAL;
        break;
    }
  }

  $scope.requirements = $scope.entity.requirements && $scope.entity.requirements.length > 0;

  if ($state.params.pk) {
    FolderService.get($state.params.pk).then(function (data) {
      $scope.parent = data;
      $scope.data.account = data.account;
    });
  } else if ($scope.parent) {
    $scope.data.account = $scope.parent.account;
  }

  $scope.showLast = function () {
    return $scope.mode === 'portfolio' || $scope.mode === 'property' || $scope.mode === 'account';
  };

  $scope.showPrivate = function () {
    var creator = $scope.entity.creator ? $scope.entity.creator.id : $scope.entity.creator;
    return (PermissionService.isOwner() || AccountUserService.currentAccountUser.id == creator) && $scope.entity.type == FolderService.TYPE_NORMAL;
  };

  $scope.getData = function () {
    var data = angular.copy($scope.data);
    if ($scope.parent) {
      data['parent'] = $scope.parent.id;
    }
    data['order'] = $scope.data.order ? 1 : 0;

    if (angular.isArray($scope.data.visible_by_roles)) {
      data['visible_by_roles'] = $scope.data.visible_by_roles;
    } else {
      data['visible_by_roles'] = $scope.data.visible_by_roles ? $scope.data.visible_by_roles.split(',') : [];
    }

    if (angular.isArray($scope.data.editable_by_roles)) {
      data['editable_by_roles'] = $scope.data.editable_by_roles;
    } else {
      data['editable_by_roles'] = $scope.data.editable_by_roles ? $scope.data.editable_by_roles.split(',') : [];
    }

    if (!$scope.requirements) {
      data['requirements'] = [];
    }
    data['propagate_to_subfolders'] = $scope.data.propagate_to_subfolders ? $scope.data.propagate_to_subfolders : false;

    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
      delete data['account'];
      delete data['sector'];
    }
    return data;
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    
    // Start the block UI before API call
    if ($scope.blockInstance) {
      $scope.blockInstance.start();
    }
    
    var data = $scope.getData();
    if ($scope.action === 'create') {
      FolderService.post(data).then(function (folder) {
        // Stop the block UI on success
        if ($scope.blockInstance) {
          $scope.blockInstance.stop();
        }
        $scope.closeThisDialog();
        $rootScope.$broadcast('folder:created', folder);
      }).catch(function(error) {
        // Stop the block UI on error
        if ($scope.blockInstance) {
          $scope.blockInstance.stop();
        }
      });
    } else {
      $scope.entity.patch(data).then(function (folder) {
        // Stop the block UI on success
        if ($scope.blockInstance) {
          $scope.blockInstance.stop();
        }
        $scope.closeThisDialog();
        $rootScope.$broadcast('folder:updated', folder);
      }).catch(function(error) {
        // Stop the block UI on error
        if ($scope.blockInstance) {
          $scope.blockInstance.stop();
        }
      });
    }
  };

  $scope.$watch('data.account', function (newValue) {
    $scope.roles = AuthDataService.getRolesValid(newValue, true);
  });

  $scope.$watch('data.editable_by_roles', function (newValue) {
    if ($scope.data.visible_by_roles && $scope.data.visible_by_roles.length > 0) {
      var visibles_array = angular.isArray($scope.data.visible_by_roles) ? $scope.data.visible_by_roles : $scope.data.visible_by_roles.split(',');
      var edibables_array = angular.isArray(newValue) ? newValue : newValue.split(',');
      angular.forEach(edibables_array, function (id) {
        if (!_.contains(visibles_array, id)) {
          visibles_array.push(id);
        }
      });
      $scope.data.visible_by_roles = visibles_array.join(',');
    }
  });
};

app.controller('FolderAddDialog', [
  '$scope',
  'FolderService',
  '$rootScope',
  '$state',
  'AuthDataService',
  'FormErrorsService',
  'AccountUserService',
  '$q',
  'AccountUserRoleService',
  'PermissionService',
  'blockUI',
  FolderAddDialog
]);
